import FieldUtil from '../../abstract-search/util/FieldUtil';
import ImagesDisplay from '../../abstract-search/projections/column-type-display/ImagesDisplay';
import Timestamp from '../../../elements/Timestamp';

let fields = [

    FieldUtil.createField(
        'Product ID',
        'product.id',
        'Product',
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'productId',
            displayComponent : Number,
        }
    ),
    FieldUtil.createField(
        'SKU',
        'product.sku',
        'Product',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'productSku',
        }
    ),
    FieldUtil.createField(
        'Title',
        'product.title',
        'Product',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'productTitle',
        }
    ),
    FieldUtil.createField(
        'Manufacturer',
        'product.manufacturer',
        'Product',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'productManufacturer',
        }
    ),
    FieldUtil.createField(
        'Cat 1',
        'product.categoryOne',
        'Product',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'categoryOne',
        }
    ),
    FieldUtil.createField(
        'Cat 2',
        'product.categoryTwo',
        'Product',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'categoryTwo',
        }
    ),

    FieldUtil.createField(
        'Product Created At',
        'product.insertedOn',
        'Product',
        FieldUtil.DATA_TYPES.timestamp,
        {
            contextKey : 'productCreatedAt',
            displayComponent : Timestamp,
        }
    ),
    FieldUtil.createField(
        'Image(s)',
        'product.images',
        'Product',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'productImages',
            displayComponent : ImagesDisplay,
            searchable : false,
            sortingDisabled : true,
        }
    ),
];

const groupNamesInOrder = ['Product'];

export default FieldUtil.buildAvailableFields(fields, groupNamesInOrder);
